import { render } from "./VerifyUser.vue?vue&type=template&id=bb0b84e4&scoped=true"
import script from "./VerifyUser.vue?vue&type=script&lang=js"
export * from "./VerifyUser.vue?vue&type=script&lang=js"

import "./VerifyUser.vue?vue&type=style&index=0&id=bb0b84e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0b84e4"]])

export default __exports__